import { useEffect } from 'react'
import { UseFormSetValue } from 'react-hook-form'

import { PatientProfileFormData } from './usePatientProfileForm'

type Params = {
  mode?: 'create' | 'edit'
  strictTraitsDirty: boolean
  insNIR: PatientProfileFormData['insNIR']
  insOID: PatientProfileFormData['insOID']
  setValue: UseFormSetValue<PatientProfileFormData>
}

export function useResetInsOnStrictTraitChange({
  mode,
  strictTraitsDirty,
  insNIR,
  insOID,
  setValue,
}: Params) {
  useEffect(() => {
    if (mode !== 'edit') return
    if (!strictTraitsDirty) return

    const hasInsData = Boolean(insNIR || insOID)
    if (!hasInsData) return

    setValue('insNIR', '')
    setValue('insOID', '')
  }, [insNIR, insOID, mode, setValue, strictTraitsDirty])
}
